export default __webpack_public_path__ + "static/media/dockpit-logo-mini.bcc39162.png";